module.exports = __webpack_public_path__ + "static/media/ami_fr.3dc069c1.png";


//////////////////
// WEBPACK FOOTER
// ./src/mi-app/digitalAssistant/assets/ami_fr.png
// module id = 565
// module chunks = 1